import { ServiceManager, ServiceBusController, ServiceBusControllerBody } from '@estee/elc-service';
import { events, on } from '@estee/elc-service-bus';

const onEvents = [[events.CART_UPDATED, 'setDeliveryMethod']];

class ServiceBus extends ServiceBusController {
    @on(events.ECOMM_STARTED, { replay: true })
    public onEcommStarted = () => {
        const id = setInterval(() => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (serviceBusBaseClass) {
                clearInterval(id);
                onEvents.forEach(ServiceManager.setDecoratorOnFunction(on));
            }
        }, 50);
    };
}

export const serviceBusBaseClass: ServiceBusController & ServiceBusControllerBody =
    new ServiceBus();
